import React from 'react';
import './ErrorScreen.css';

function ErrorScreen({ error, onRetry }) {
  return (
    <div className="error-screen">
      <div className="error-content">
        <div className="error-icon">⚠</div>
        <h2 className="error-title">Error al iniciar AR</h2>
        <p className="error-message">{error || 'No se pudo acceder a la cámara o iniciar la experiencia de realidad aumentada.'}</p>
        <p className="error-hint">
          Asegúrate de permitir el acceso a la cámara y usar HTTPS en dispositivos móviles.
        </p>
        <button className="error-retry-btn" onClick={onRetry}>
          Reintentar
        </button>
      </div>
    </div>
  );
}

export default ErrorScreen;
